export enum ColumnsPreset {
  Preset1 = 1,
  Preset2 = 2,
  Preset3 = 3,
}

export type IShowColumns = Array<string[] | null>;
